import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { ViewState } from '#components/Root/viewModel'
import type { Transitioner } from '#components/TransitionProvider'

import * as mobx from 'mobx'
import PT from 'prop-types'

export type Props = {
  state: ViewState
}

export type ViewModel = {
  showButtons: boolean
  showContinue: boolean
  showBack: boolean
  isValid: boolean
  searchTerm?: string | null

  handleNext: () => void
  handleSearchFormChange: (args: { term: string }) => void
}

type Context = {
  transitioner: Transitioner
}

const mkViewModel = (
  _params: Params,
  { state }: Props,
  { transitioner }: Context,
): ViewModel => {
  const vm = mobx.observable({
    searchTerm: '',
    get showButtons() {
      // @ts-expect-error@2339
      return vm.showContinue || vm.showBack || vm.showCancel
    },
    get showContinue() {
      return state.currentNode.nodes.some(
        (child) => child.contentModelType === 'selectNode' && child.radios,
      )
    },
    get showBack() {
      return state.currentNode && state.currentNode.allowBack
    },
    get isValid() {
      return state.nextNode
    },

    handleNext: mobx.action(() => {
      transitioner.goForward(state.nextNode)
    }),
    handleSearchFormChange: mobx.action(({ term }) => {
      vm.searchTerm = term && term.length >= 3 ? term : ''
    }),
  })

  return vm
}

mkViewModel.contextTypes = {
  transitioner: PT.object.isRequired,
}

export default mkViewModel
